import type { ModifierSet } from '../../types/patientJourney';

type ReproductiveStatus = ModifierSet['reproductiveStatus'];

interface PregnancyModalProps {
  onSubmit: (status: ReproductiveStatus) => void;
}

const OPTIONS: { value: ReproductiveStatus; label: string }[] = [
  { value: 'pregnant', label: "Yes, I\u2019m pregnant" },
  { value: 'trying_to_conceive', label: 'Trying to conceive' },
  { value: 'breastfeeding', label: 'Breastfeeding' },
  { value: 'postmenopausal', label: 'Postmenopausal' },
];

export function PregnancyModal({ onSubmit }: PregnancyModalProps) {
  return (
    <div style={{ animation: 'msgIn 0.3s ease' }}>
      <div className="bg-bg-card border border-bg-tertiary rounded-xl p-4">
        <p className="text-sm font-medium mb-1">
          Are you currently pregnant, breastfeeding, or planning a pregnancy?
        </p>
        <p className="text-xs text-text-muted mb-4">
          Certain biological factors require specialized consideration during pregnancy or while breastfeeding.
          This helps us ensure your personalized analysis remains safe.
        </p>

        <div className="flex flex-col gap-2">
          {OPTIONS.map(({ value, label }) => (
            <button
              key={value}
              onClick={() => onSubmit(value)}
              className="w-full py-2.5 rounded-lg border border-bg-tertiary text-text-primary text-sm
                hover:border-accent/40 transition-colors text-left px-4"
            >
              {label}
            </button>
          ))}
          <button
            onClick={() => onSubmit('not_applicable')}
            className="w-full py-2.5 rounded-lg bg-accent text-white text-sm font-medium
              hover:bg-accent-light transition-colors"
          >
            None of these apply
          </button>
        </div>
      </div>
    </div>
  );
}
